import React from 'react';
import _ from 'lodash';
import { useMutation } from 'react-fetching-library';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Select,
  MenuItem,
  Tooltip,
  Rating,
  Grid,
  IconButton,
  Typography,
  Card,
  CardHeader,
  Stack,
  CircularProgress,
  Box,
  FormControl,
  InputLabel,
  FormLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  FormControlLabel
} from '@mui/material';
import { DataGridPro, GridRow } from '@mui/x-data-grid-pro';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {
  employeeReviewsColumns
} from '../../../../../services/column-definitions';
import {
  submitEmployeeReviewRecord,
  deleteEmployeeReviewRecord
} from '../../../../../services/request';
import { useEmployees } from '../../EmployessContext';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';

export default function Reviews() {
  const { rowData, setRowData, choices } = useEmployees();
  // const { query } = useParameterizedQuery(downloadAttachmentAction);
  const { mutate, loading } = useMutation(submitEmployeeReviewRecord);
  const { mutate: deleteMutate } = useMutation(deleteEmployeeReviewRecord);
  const [confirmDeleteModal, setConfirmDeleteModal] = React.useState(false);
  const [addEditModal, setAddEditModal] = React.useState(false);
  const [activeData, setActiveData] = React.useState({});
  // const [addEditData, setAddEditData] = React.useState({});
  const [expandedRows, setExpandedRows] = React.useState({});

  console.log(rowData.reviews);
  console.log('c', choices);

  const handleOpenAddEditModal = rowData => {
    setActiveData(rowData);
    setAddEditModal(true);
  };

  const handleOpenDeleteModal = rowData => {
    setActiveData(rowData);
    setConfirmDeleteModal(true);
  };

  const handleCloseOpenAddEditModal = () => {
    setAddEditModal(false);
    setActiveData({});
  };

  // const handleSetActiveDocument = async (id, name, file_url) => {
  //   const { payload, error, loading } = await query(id);

  //   if (!error) {
  //     const url = window.URL.createObjectURL(payload);
  //     setActiveDocument({ uri: url, fileName: name, file_url });
  //   } else {
  //     toast.error('Nie udało się otworzyć załącznika');
  //   }
  // };

  const handleDelete = async id => {
    const { error } = await deleteMutate(id);
    if (!error) {
      setRowData(prev => ({
        ...prev,
        reviews: prev.reviews.filter(element => element.id !== id)
      }));
      toast.success('Opinia została usunięta');
    }

    if (error) {
      toast.error('Nie udało się usunąć opinii');
    }
    setActiveData({});
  };

  const handleSubmit = async values => {
    const id = activeData.id || null;
    const { payload, loading, error } = await mutate(id, values);
    if (!error && !loading) {
      setRowData(prev => ({
        ...prev,
        reviews: id
          ? prev.reviews.map(review => (review.id === id ? payload : review)) // Aktualizacja istniejącego elementu
          : [payload, ...prev.reviews] // Dodanie nowego elementu
      }));
      toast.success(`Rekord został ${id ? 'edytowany' : 'dodany'}`);
      handleCloseOpenAddEditModal();
      setActiveData({});
    }

    if (error) {
      toast.error(`Nie udało ${id ? 'edytować' : 'dodać'} rekordu`);
    }
  };

  const handleRowClick = id => {
    setExpandedRows(prev => ({
      [id]: !prev[id] // Przełączanie stanu rozwinięcia
    }));
  };

  const AccordionRow = props => {
    const isExpanded = expandedRows[props.row.id];

    return (
      <div>
        <GridRow {...props} onClick={() => handleRowClick(props.row.id)} />
        {isExpanded && (
          <div
            style={{
              padding: '24px',
              fontSize: '0.5rem',
              backgroundColor: '#f9f9f9'
            }}
          >
            {/* Siatka dla "grades" */}
            <Grid container spacing={2}>
              {props.row.grades.map(grade => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={grade.id} // Maksymalnie 6 elementów w rzędzie na dużych ekranach
                >
                  <Typography variant="subtitle1" ml={1}>
                    {grade.category_display}
                  </Typography>
                  <Rating
                    name="read-only"
                    value={grade.value}
                    max={6}
                    readOnly
                  />
                </Grid>
              ))}
            </Grid>
            {/* Siatka dla opisu */}
            <Grid container spacing={2} style={{ marginTop: '16px' }}>
              <Grid item xs={12} lg={4}>
                <Stack>
                  <Typography variant="h6">Umiejętności z zakresu programu</Typography>
                  <Typography>{props.row.programming_skills}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Stack>
                  <Typography variant="h6">Predyspozycje wychowawcze</Typography>
                  <Typography>{props.row.educational_predispositions}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Stack>
                  <Typography variant="h6">Specjalista (umiejętności i predyspozycje)</Typography>
                  <Typography>{props.row.special_skills}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Typography variant="h6">Dłuższy opis</Typography>
                  <Typography>{props.row.description}</Typography>
                </Stack>
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Card style={{ height: '100%', border: '2px solid transparent' }}>
        <CardHeader
          action={
            loading ? (
              <Box sx={{ p: '8px', height: '40px' }}>
                <CircularProgress size={24} />
              </Box>
            ) : (
              <Tooltip title="Dodaj">
                <IconButton
                  color="primary"
                  component="label"
                  onClick={() => setAddEditModal(true)}
                >
                  <AddCircleIcon />
                </IconButton>
              </Tooltip>
            )
          }
        />
        <DataGridPro
          rows={rowData.reviews === undefined ? [] : rowData.reviews}
          columns={employeeReviewsColumns(
            handleOpenAddEditModal,
            handleOpenDeleteModal
          )}
          // components={{
          //   NoRowsOverlay: () => (
          //     <Stack height="100%" alignItems="center" justifyContent="center">
          //       Brak ocen
          //     </Stack>
          //   )
          // }}
          components={{
            Row: AccordionRow,
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                Brak wystawionych opinii
              </Stack>
            )
          }}
        />
        <ConfirmDialog
          open={confirmDeleteModal}
          setOpen={setConfirmDeleteModal}
          onConfirm={() => handleDelete(activeData.id)}
        >
          <p>
            Czy na pewno chcesz usunąć opinię <b>{activeData?.value}</b>?
          </p>
        </ConfirmDialog>
      </Card>
      <FormModal
        open={addEditModal}
        onClose={handleCloseOpenAddEditModal}
        handleSubmit={handleSubmit}
        data={activeData}
      />
    </>
  );
}

const FormModal = ({ open, onClose, handleSubmit, data }) => {
  const { rowData, choices } = useEmployees();

  const formik = useFormik({
    initialValues: {
      employee: rowData.id || '',
      application: data.application || null,
      camp: data.camp || null,
      resort: data.resort || null,
      event: data.event || null,
      periods_type: data.periods_type || null,
      zs_timed_periods: data.zs_timed_periods || null,
      programming_skills: data.programming_skills || '',
      educational_predispositions: data.educational_predispositions || '',
      special_skills: data.special_skills || '',
      description: data.description || '',
      grades: []
    },
    validateOnChange: false,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  React.useEffect(() => {
    // Tworzymy mapę istniejących ocen na podstawie kategorii
    const existingGradesMap = new Map(
      (data.grades || []).map(g => [g.category, g.value])
    );

    // Tworzymy pełną listę ocen
    const fullGrades = choices.grades_categories.map(item => ({
      name: item.label,
      category: item.value,
      value: existingGradesMap.has(item.value)
        ? existingGradesMap.get(item.value)
        : null
    }));

    formik.setValues({
      employee: rowData.id || '',
      application: data.application || null,
      camp: data.camp || null,
      resort: data.resort || null,
      event: data.event || null,
      periods_type: data.periods_type || null,
      zs_timed_periods: data.zs_timed_periods || null,
      programming_skills: data.programming_skills || '',
      educational_predispositions: data.educational_predispositions || '',
      special_skills: data.special_skills || '',
      description: data.description || '',
      grades: fullGrades
    });
  }, [data]);

  const handleRadioChange = event => {
    formik.setFieldValue('periods_type', event.target.value);
    formik.setFieldValue('camp', null);
    formik.setFieldValue('resort', null);
    formik.setFieldValue('event', null);
    formik.setFieldValue('period', null);
  };

  console.log(choices);

  const availableEvents = (choices.camp_events || []).filter(event => (
    String(event.resort) === String(formik.values.resort) &&
    event.camps.some(campId => String(campId) === String(formik.values.camp))
  ));

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{data.id ? 'Edytuj opinię' : 'Dodaj opinię'}</DialogTitle>
      <DialogContent sx={{ minWidth: '400px' }} spacing={2}>
        <Box sx={{ height: 20 }}></Box>
        <Stack spacing={2}>
          <FormControl>
            <InputLabel>Aplikacja</InputLabel>
            <Select
              name="application"
              id="application_field"
              value={formik.values.application}
              onChange={formik.handleChange}
              fullWidth
            >
              {rowData.applications?.map(obj => (
                <MenuItem value={obj.id} key={obj.id}>
                  Aplikacja nr {obj.id} - {obj.function_type_display}
                </MenuItem>
              )) || []}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel id="period-type-label">Rodzaj terminu</FormLabel>
            <RadioGroup
              aria-labelledby="period-type-label"
              name="periods_type"
              value={formik.values.periods_type}
              onChange={handleRadioChange}
            >
              <FormControlLabel
                value="obozy"
                control={<Radio />}
                label="Obozy"
              />
              <FormControlLabel
                value="zielone_szkoly"
                control={<Radio />}
                label="Zielone szkoły"
              />
            </RadioGroup>
          </FormControl>

          {formik.values.periods_type === 'obozy' && (
            <>
              <FormControl>
                <InputLabel>Obóz</InputLabel>
                <Select
                  name="camp"
                  id="camp_field"
                  value={formik.values.camp}
                  onChange={formik.handleChange}
                  fullWidth
                >
                  {rowData.choices?.camps?.map(obj => (
                    <MenuItem value={obj.value} key={obj.value}>
                      {obj.label}
                    </MenuItem>
                  )) || <MenuItem disabled>Brak dostępnych obozów</MenuItem>}
                </Select>
              </FormControl>

              <FormControl>
                <InputLabel>Ośrodek</InputLabel>
                <Select
                  name="resort"
                  id="resort_field"
                  value={formik.values.resort}
                  onChange={formik.handleChange}
                  fullWidth
                >
                  {choices.review_resorts?.map(obj => (
                    <MenuItem value={obj.value} key={obj.value}>
                      {obj.label}
                    </MenuItem>
                  )) || []}
                </Select>
              </FormControl>

              {formik.values.camp && formik.values.resort && (
                <FormControl>
                  <InputLabel>Impreza</InputLabel>
                  <Select
                    name="event"
                    id="event_field"
                    value={formik.values.event}
                    onChange={formik.handleChange}
                    fullWidth
                  >
                    {availableEvents.length ? (
                      availableEvents.map(obj => (
                        <MenuItem value={obj.value} key={obj.value}>
                          {obj.label}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>Brak imprez dla wybranego turnusu</MenuItem>
                    )}
                  </Select>
                  {!formik.values.event && data.event_legacy != null && (
                    <FormHelperText>
                      Zapisana wartość (historyczna): {data.event_display}. Wybór nowej
                      imprezy z listy zastąpi tę wartość.
                    </FormHelperText>
                  )}
                </FormControl>
              )}
            </>
          )}

          {formik.values.periods_type === 'zielone_szkoly' && (
            <FormControl>
              <InputLabel>Termin</InputLabel>
              <Select
                name="zs_timed_periods"
                id="zs_timed_periods_field"
                value={formik.values.zs_timed_periods?.nr || ''}
                onChange={event => {
                  const selectedObj = choices.manager_zs_periods.find(
                    obj => obj.nr === event.target.value
                  );
                  formik.setFieldValue('zs_timed_periods', selectedObj); // Zapisujemy cały obiekt
                }}
                fullWidth
              >
                {choices.manager_zs_periods?.map(obj => (
                  <MenuItem value={obj.nr} key={obj.nr}>
                    {obj.name}
                  </MenuItem>
                )) || <MenuItem disabled>Brak dostępnych terminów</MenuItem>}
              </Select>
            </FormControl>
          )}

          {formik.values.grades.map((grade, index) => (
            <Box
              key={grade.category}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2
              }}
            >
              <Typography sx={{ minWidth: 200 }}>
                {grade.name.toLowerCase()}
              </Typography>
              <Rating
                name={`grades.${index}.value`}
                value={formik.values.grades[index]?.value || 0}
                onChange={(event, newValue) => {
                  formik.setFieldValue(`grades.${index}.value`, newValue);
                }}
                max={6}
                size="large"
              />
            </Box>
          ))}

          <TextField
            name="programming_skills"
            fullWidth
            label="Umiejętności z zakresu programu"
            value={formik.values.programming_skills}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.programming_skills)}
            helperText={formik.errors.programming_skills}
          />
          <TextField
            name="educational_predispositions"
            fullWidth
            label="Predyspozycje wychowawcze"
            value={formik.values.educational_predispositions}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.educational_predispositions)}
            helperText={formik.errors.educational_predispositions}
          />
          <TextField
            name="special_skills"
            fullWidth
            label="Specjalista (umiejętności i predyspozycje)"
            value={formik.values.special_skills}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.special_skills)}
            helperText={formik.errors.special_skills}
          />
          <TextField
            name="description"
            multiline
            rows={4}
            fullWidth
            label="Dłuższy komentarz"
            value={formik.values.description}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.description)}
            helperText={formik.errors.description}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={formik.handleSubmit}
          color="primary"
          variant="contained"
        >
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
};
